module.exports = __webpack_public_path__ + "static/media/1POLICY24.143af0b9.jpg";